
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.357 37.916l2.083-2.083m33.643-31.25L39.167 2.5","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('rect',{attrs:{"width":"2.587","height":"3.333","rx":"1.294","transform":"rotate(-45 43.327 14.411)","fill":"#FFF5E8"}}),_c('path',{attrs:{"d":"M6.667 35.277L4.93 37.013l-2.43-2.43L4.583 32.5","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.505 34.131c-3.732-3.804-3.713-9.953.091-13.684l3.932-3.858 13.593 13.856-3.932 3.857c-3.804 3.732-9.953 3.633-13.684-.171z","fill":"#FFF5E8"}}),_c('path',{attrs:{"d":"M9.334 17.356a1.667 1.667 0 012.358 0l11.785 11.785a1.667 1.667 0 010 2.357c-1.166 1.176-1.451 1.451-3.638 3.638a9.639 9.639 0 01-13.552-.588A9.639 9.639 0 015.7 20.999l3.635-3.643zm5.676 3.061l3.323-3.322m2.084 8.725l3.32-3.32","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M31.298 23.616a1.666 1.666 0 01-2.359 0L17.154 11.83a1.667 1.667 0 010-2.357c1.167-1.177 1.452-1.452 3.639-3.638a9.638 9.638 0 0113.551.588 9.639 9.639 0 01.589 13.548l-.984.989-2.651 2.655z","fill":"#fff","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M33.965 5.208l1.737-1.736 2.43 2.43-1.736 1.737","fill":"#fff"}}),_c('path',{attrs:{"d":"M33.965 5.208l1.737-1.736 2.43 2.43-1.736 1.737","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    